<div class="enis-sync-log-container">
  <h1>ENISSYNC Log</h1>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading latest ENISSYNC operation...</p>
  </div>

  <div *ngIf="error && !loading" class="error-container">
    <mat-icon color="warn">error</mat-icon>
    <p>{{ error }}</p>
  </div>

  <div *ngIf="!loading && !error && latestSync">
    <!-- Summary Card -->
    <mat-card class="summary-card">
      <mat-card-header>
        <mat-card-title>Latest ENISSYNC Operation</mat-card-title>
        <mat-card-subtitle>{{ formatDate(latestSync.syncDate) }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="summary-grid">
          <div class="summary-item">
            <span class="label">User:</span>
            <span class="value">{{ latestSync.username }}</span>
          </div>
          <div class="summary-item" *ngIf="latestSync.fileName">
            <span class="label">File:</span>
            <span class="value">{{ latestSync.fileName }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Total Participants:</span>
            <span class="value">{{ latestSync.totalParticipants }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Successful:</span>
            <span class="value success">{{ latestSync.successfulImports }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Failed:</span>
            <span class="value failed">{{ latestSync.failedImports }}</span>
          </div>
        </div>

        <div *ngIf="latestSync.generalErrors" class="general-errors">
          <h3>General Errors:</h3>
          <p class="error-message">{{ latestSync.generalErrors }}</p>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Participants Table -->
    <mat-card class="participants-card">
      <mat-card-header>
        <mat-card-title>Participant Details</mat-card-title>
        <mat-card-subtitle>{{ latestSync.participants?.length || 0 }} participants</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <table mat-table [dataSource]="latestSync.participants" class="participants-table">
          <!-- ENIS Number Column -->
          <ng-container matColumnDef="enisNumber">
            <th mat-header-cell *matHeaderCellDef>ENIS Number</th>
            <td mat-cell *matCellDef="let participant">{{ participant.enisNumber }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="participantName">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let participant">{{ participant.participantName || 'N/A' }}</td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let participant">
              <mat-chip class="type-chip">{{ participant.participantType }}</mat-chip>
            </td>
          </ng-container>

          <!-- Center Column -->
          <ng-container matColumnDef="center">
            <th mat-header-cell *matHeaderCellDef>Center</th>
            <td mat-cell *matCellDef="let participant">{{ participant.center || 'N/A' }}</td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let participant">
              <mat-chip [color]="getStatusColor(participant.status)">
                <mat-icon>{{ getStatusIcon(participant.status) }}</mat-icon>
                {{ participant.status }}
              </mat-chip>
            </td>
          </ng-container>

          <!-- Missing Fields Column -->
          <ng-container matColumnDef="missingFields">
            <th mat-header-cell *matHeaderCellDef>Missing Fields</th>
            <td mat-cell *matCellDef="let participant">
              <div *ngIf="getMissingFieldsList(participant).length > 0" class="missing-fields">
                <mat-chip *ngFor="let field of getMissingFieldsList(participant)" class="missing-field-chip">
                  {{ field }}
                </mat-chip>
              </div>
              <span *ngIf="getMissingFieldsList(participant).length === 0" class="no-data">-</span>
            </td>
          </ng-container>

          <!-- Error Message Column -->
          <ng-container matColumnDef="errorMessage">
            <th mat-header-cell *matHeaderCellDef>Error Message</th>
            <td mat-cell *matCellDef="let participant">
              <span *ngIf="participant.errorMessage" class="error-message">{{ participant.errorMessage }}</span>
              <span *ngIf="!participant.errorMessage" class="no-data">-</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>

  <div *ngIf="!loading && !error && !latestSync" class="no-data-container">
    <mat-icon>info</mat-icon>
    <p>No ENISSYNC operations found.</p>
  </div>
</div>
